// * Import 3rd party
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTypography = styled(
  Typography,
  {}
)(({ theme, customProps }) => ({
  // fontSize: '14px',
  color: theme.palette.text.secondary,
  fontWeight: theme.fontWeight[600],
}));

export default StyledTypography;
